@if (productItem) {
  <card-block
    onScrollView (viewStateChange)="trackViewListItem($event.isVisible)" [once]="true"
    [state]="{ itemListId: itemListId, itemListName: itemListName}"
    class="h-full w-full bg-white shadow-card rounded-md relative"
    [id]="productItem._id"
    [title]="productItem.name"
    [text]="productItem.shortDescription"
    [image]="productItem.images[0]"
    [fallbackImage]="productFallbackImage"
    [imageSizes]="imageSizes"
    [views]="productItem.views"
    [url]="urlPrefix +  productItem.slug"
    (onItemSelected)="trackItemSelected()"
    [footerTpl]="productActionTpl">
    <ng-content></ng-content>
  </card-block>
  
  <!-- Product action -->
  <ng-template #productActionTpl>
    <expo-button 
      class="absolute bottom-2 right-2" 
      (click)="!isSavedProduct() ? toggleSaveProduct('save') : toggleSaveProduct('remove')"
      [animate]="false">
      {{ !isSavedProduct() ? 'Save' : 'Remove' }}
    </expo-button>
  </ng-template>
}
@if (productItem?.productStatus === productStatusEnum.draft) {
  <div class="status-label draft" i18n>draft</div>
}
@if (productItem?.productStatus === productStatusEnum.suspended) {
  <div class="status-label suspended" i18n>suspended</div>
}
@if (!productItem) {
  <loading-card-block  class="h-full w-full"></loading-card-block>
}
